export enum ServiceType {
	CONNECTIVITY = 'CONNECTIVITY',
	SOFTWARE = 'SOFTWARE',
	MAINTENANCE = 'MAINTENANCE',
}
